import Axios from 'axios';
import store from '@/store';

// 通过请求静态资源获取最新的版本号并更新缓存
export const checkVersion = () => {
  return new Promise((resolve, reject) => {
    try {
      const url = `/version.json?v=${new Date().getTime()}`;
      Axios.get(url, {
        headers: { 'Cache-Control': 'no-cache' }, // 禁止缓存
        baseURL: window.location.origin,
      }).then((res) => {
        if (res.status === 200) {
          const { version } = res.data;
          // version为vue.config.js定义的name值
          const { version: metaVersion } = document.getElementsByTagName('meta');
          const content = metaVersion ? metaVersion.content : 0;
          const clientVersion = Number(content ?? 0);
          if (version !== clientVersion) {
            resolve(true);
            store.dispatch('app/showVersionTipActions', true);
          } else {
            resolve(false);
            store.dispatch('app/showVersionTipActions', false);
          }
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};
